import React, { useEffect } from 'react'
import { ThemeProvider } from '@mui/styles';
import App from './App'
import { VideoProvider } from './components/VideoProvider';
import AppStateProvider, { useAppState } from './state';
import useConnectionOptions from './utils/useConnectionOptions/useConnectionOptions';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import { ParticipantProvider } from './components/ParticipantProvider';
import theme from './theme';
import { CssBaseline } from '@mui/material';
import UnsupportedBrowserWarning from './components/UnsupportedBrowserWarning/UnsupportedBrowserWarning';
import { useGetUserInfoQuery } from '../services/api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const AppWrap = () => {
  const { error, setError } = useAppState();
  const connectionOptions = useConnectionOptions();
  const { data: user, isLoading: isUserLoading } = useGetUserInfoQuery();
  const { guid } = useParams<{ guid: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('user', { user, isUserLoading })
    if (isUserLoading)
      return;

    if (!user?.guid) {
      navigate(`/login?redirectUrl=${encodeURIComponent(location.pathname + '?' + location.search)}`, {
        state: {
          redirectUrl: location
        }
      })
    }
    else if (!guid) {
      navigate('/dashboard')
    }
  }, [isUserLoading, location, navigate, user, guid]);

  if (!user)
    return null;

  return (
    <VideoProvider options={connectionOptions} onError={setError}>
      <ErrorDialog dismissError={() => setError(null)} error={error} />
      <ParticipantProvider>
        <App />
      </ParticipantProvider>
    </VideoProvider>
  );
};

export default function VideoApp() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UnsupportedBrowserWarning>
        <AppStateProvider>
          <AppWrap />
        </AppStateProvider>
      </UnsupportedBrowserWarning>
    </ThemeProvider>
  )
}